import UnityBridge from '../unityBridge'
import { isUnityUA } from '../uaConfig'
import { SLSEventData } from './slsApp'

export function transformEventDataToQueryString(data: SLSEventData): string {
  const queryString = Object.entries(data)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
    .join('&')

  return `${queryString}`
}

export function slsUnitySend() {
  const userAgent = navigator.userAgent.toLowerCase()

  const slsSendEvent = (data: SLSEventData) => {
    if (isUnityUA(userAgent)) {
      // const slsSendEventString = transformEventDataToQueryString(data)
      const slsSendEventString = JSON.stringify(data)
      UnityBridge.callHandler(`slsSendEvent&${slsSendEventString}`, (_, data) => {
        console.log(data)
      })
    }
  }

  return { slsSendEvent }
}
